/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.feather = require('feather-icons');
require('./partials/utils.js');
require('./partials/footer.js');
require('./partials/navigation.js');
require('./partials/scroll-to-top.js');
require('./partials/forms.js');
require('./partials/misc.js');
require('./partials/forum-login.js');

// custom feather icons
const IconConstructor = window.feather.icons.activity.constructor;

window.feather.icons.rankings = new IconConstructor(
  'rankings',
  `
  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="belt" transform="translate(1.000000, 6.000000)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <ellipse cx="11.0418182" cy="5.488" rx="6.86" ry="5.488"></ellipse>
        <path d="M4.96590909,2.94 C1.81108719,2.94 0.233676235,2.94 0.233676235,2.94 C-0.111087045,3.24774536 -0.0428336868,8.15306885 0.233676235,8.428 C0.233676235,8.428 1.81108719,8.428 4.96590909,8.428" id="Path-3"></path>
        <path d="M21.9761825,2.94 C18.8036199,2.94 17.2173386,2.94 17.2173386,2.94 C16.911837,3.24774536 16.9723177,8.15306885 17.2173386,8.428 C17.2173386,8.428 18.6151136,8.428 21.4106636,8.428" id="Path-3-Copy" transform="translate(19.493228, 5.684000) rotate(-180.000000) translate(-19.493228, -5.684000) "></path>
    </g>
    <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
</g>
  `,
);

window.feather.icons.twitternew = new IconConstructor(
  'twitternew',
  '<path d="M1.05353 2L9.54748 13.0311L1 22H2.92385L10.4073 14.1475L16.4535 22H23L14.028 10.3485L21.984 2H20.0601L13.1685 9.23182L7.6 2H1.05353ZM3.88263 3.37629H6.89005L20.1705 20.6237H17.1631L3.88263 3.37629Z" fill="currentColor"/>',
);

window.feather.replace();

$(() => {

  // const headerEl = $('header.header')[0];
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.intersectionRatio >= 1) {
        // headerEl.classList.remove('scrolled');
        // $('body').removeClass('scrolled');
      } else {
        // headerEl.classList.add('scrolled');
        // $('body').addClass('scrolled');
      }
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.25, 0.5, 0.75, 1],
    },
  );

  let elToObserve;
  if ($(window).width() >= 768) {
    elToObserve = $('#channel-tabbar')[0];
  } else {
    elToObserve = $('.mobile-forum-nav.d-md-none')[0];
  }
  observer.observe(elToObserve);
});
